export interface TimelineData {
  timeline: TimelineValue[];
  timepoints: TimepointValue[];
}

export interface TimelineValue {
  forklift: string;
  timeFrom: Date;
  timeTo: Date;
  type: TimelineTypes;
}

export interface TimepointValue {
  forklift: string;
  time: Date;
  type: TimelineTypes;
  strength: number;
}

export enum TimelineTypes {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  STRONG = 'strong',
  WEAK = 'weak'
}
